import {
	buildDataForPageView,
	handleFormChange,
	hasInventoryWidget,
	isFeaturedVehiclePage,
	formDisplayType,
	getFormType,
	linkGeneric,
	mapVehicle,
	getInventoryType,
	setFilterValueToSend
} from '../../../utils/shiftnative/utils';
import getEnv from '../../../utils/getEnv';
import findDealerCode from '../../../utils/findDealerCode';

const getFilterSearchEventPayload = ({ eventData }) => {
	const priceFilter =
		eventData.queryFacets.internetPrice || eventData.queryFacets.msrp;

	const filterSearchData = {
		status: getInventoryType(),
		year: setFilterValueToSend(eventData.queryFacets.year, ', '),
		make: setFilterValueToSend(eventData.queryFacets.make, ', '),
		model: setFilterValueToSend(eventData.queryFacets.model, ', '),
		trim: setFilterValueToSend(eventData.queryFacets.trim, ', '),
		color: setFilterValueToSend(
			eventData.queryFacets.normalExteriorColor,
			', '
		),
		minPrice: priceFilter ? priceFilter.split('-')[0] : 'All',
		maxPrice: priceFilter ? priceFilter.split('-')[1] : 'All',
		bodyStyle: setFilterValueToSend(
			eventData.queryFacets.bodyStyle ||
				eventData.queryFacets.normalBodyStyle,
			', '
		),
		features: setFilterValueToSend(eventData.queryFacets.gvOption, ' | ')
	};

	localStorage.setItem('ShiftFilterEvents', JSON.stringify(eventData));

	return {
		data: {
			countSearchResults: eventData.resultCount,
			filterSearch: filterSearchData,
			events: 'filterSearch'
		}
	};
};

export default {
	events: {
		'ddc.wstagging.first': [
			{
				payload: ({
					mapping: {
						configuration: {
							clientId = '',
							locationCode = '',
							retailerId = '',
							saveShiftSessionId = false
						} = {}
					} = {}
				}) => {
					let retailerIdToUse = findDealerCode(
						window?.DDC?.dataLayer?.dealership?.dealerCode || '',
						retailerId
					);

					if (locationCode) {
						const locationCodeToUse = findDealerCode(
							window?.DDC?.dataLayer?.dealership?.dealerCode ||
								'',
							locationCode
						);
						retailerIdToUse = `${retailerIdToUse}-${locationCodeToUse}`;
					}

					window.sd(
						'create',
						clientId,
						retailerIdToUse,
						'DealerDotCom'
					);

					if (saveShiftSessionId || getEnv() !== 'prod') {
						window.sd('getSessionId', (sessionId) => {
							window.sessionStorage.setItem(
								'SaveShiftSession',
								sessionId
							);
						});
					}

					return {};
				}
			}
		],
		'ddc.page.view': [
			{
				payload: ({ eventData, mapping }) => {
					const payloads = [];
					const {
						page: {
							attributes: { vehicleResultCount } = {},
							pageInfo: {
								isVdp = false,
								pageName = '',
								pageWidgets = []
							} = {}
						} = {}
					} = window?.DDC?.dataLayer || {};

					const urlSearchParams = new URLSearchParams(
						window.DDC.dataLayer.page?.pageInfo?.params
					);
					const search = urlSearchParams.get('search');

					const data = buildDataForPageView({
						mapping
					});

					window.DDC.WidgetData[
						'ws-tagging'
					].mapping.shiftnative.pageType = data.pageType;

					if (!pageWidgets.includes('ws-inv-listing')) {
						payloads.push({
							data,
							event: 'pageview'
						});
					} else if (
						pageWidgets.includes('ws-inv-listing') &&
						search
					) {
						const payload = getFilterSearchEventPayload({
							eventData: {
								...eventData,
								queryFacets:
									Object.fromEntries(urlSearchParams),
								resultCount: vehicleResultCount
							}
						});
						payloads.push({
							data,
							event: 'pageview'
						});
						payloads.push({
							data: payload.data
						});
					}

					if (isVdp) {
						payloads.push({
							data: {
								...data,
								displayType: 'in-page',
								events: 'detailsView'
							}
						});
					}

					if (
						isFeaturedVehiclePage({
							pageName,
							pageWidgets
						})
					) {
						let alias;

						if (pageName === 'INVENTORY_FEATURED_NEW') {
							alias = 'New';
						} else if (pageName === 'INVENTORY_FEATURED_USED') {
							alias = 'Used';
						} else if (pageName.includes('CERTIFIED')) {
							alias = 'CPO';
						} else {
							alias = 'Mixed';
						}

						payloads.push({
							data: {
								'filterSearch.status': alias,
								events: 'filterSearch'
							},
							event: 'filterSearch'
						});
					}

					return payloads;
				}
			}
		],
		'ddc.inventory.filterSearch': [
			{
				logic: () => {
					const {
						page: {
							attributes: { vehicleResultCount } = {},
							pageInfo: {
								isVlp = false,
								pageName = '',
								pageWidgets = []
							} = {}
						} = {}
					} = window.DDC.dataLayer;
					return hasInventoryWidget({
						isVlp,
						pageName,
						pageWidgets,
						vehicleResultCount
					});
				},
				payload: ({ eventData, mapping }) => {
					const data = buildDataForPageView({
						mapping
					});
					return [
						{
							data,
							event: 'pageview'
						},
						getFilterSearchEventPayload({ eventData })
					];
				}
			}
		],
		'wallet:updated': [
			{
				payload: () => {
					return {
						data: {
							events: 'myWalletClick'
						}
					};
				},
				fireGroup: 'walletClick'
			}
		],
		'ddc.form.onPage': [
			{
				logic: ({ eventData }) => eventData?.isLead,
				payload: ({ mapping, eventData }) => {
					const { isModal, trackingId } = eventData;

					return {
						data: {
							formType: getFormType({
								trackingId,
								mapping
							}),
							events: 'formShown',
							displayType: formDisplayType(isModal),
							formVehicle: mapVehicle({
								vehicle: eventData?.vehicle
							})
						},
						event: 'formShown'
					};
				}
			}
		],
		'ddc.form.typedSearch': [
			{
				logic: () => {
					const {
						page: {
							attributes: { vehicleResultCount } = {},
							pageInfo: {
								isVlp = false,
								pageName = '',
								pageWidgets = []
							} = {}
						} = {}
					} = window.DDC.dataLayer;
					return hasInventoryWidget({
						isVlp,
						pageName,
						pageWidgets,
						vehicleResultCount
					});
				},
				payload: ({ eventData, mapping }) => {
					const { trackingId, typedSearchContent = '' } =
						eventData || {};

					return {
						data: {
							events: 'typedSearch',
							formType: getFormType({
								trackingId,
								mapping
							}),
							typedSearchContent:
								typedSearchContent?.replace?.(
									/([\s,|]+)/g,
									'|'
								) || ''
						}
					};
				}
			}
		],
		'ddc.form.initiation': [
			{
				logic: ({ eventData }) =>
					eventData?.trackingId !== 'INVENTORY_SEARCH',
				payload: ({ element, eventData, mapping }) => {
					const { isModal, trackingId, vehicle } = eventData || {};
					const form = element?.closest?.('form');

					// if form has formOptIn field, get the default value of opt-in field
					// cemConsent: GM
					// endorsedCareADF: Genesis
					const cemConsent = form?.querySelector(
						'[data-id="cemConsent"]'
					);

					if (cemConsent) {
						sessionStorage.setItem(
							'cemConsentDefaultValue',
							cemConsent.defaultChecked
						);
					}

					const endorsedCare = form?.querySelector(
						'[data-id="endorsedCareADF"]'
					);

					if (endorsedCare) {
						sessionStorage.setItem(
							'cemConsentDefaultValue',
							endorsedCare.value === 'checked'
						);
					}

					return {
						data: {
							events: 'formInitiation',
							formType: getFormType({
								trackingId,
								mapping
							}),
							displayType: formDisplayType(isModal),
							formVehicle: mapVehicle({
								vehicle
							})
						}
					};
				}
			}
		],
		'ddc.slideshow.click': [
			{
				payload: ({ eventData }) => {
					return {
						event: 'carouselClick',
						data: {
							events: 'carouselClick',
							carouselClick: {
								assetPosition: eventData.position,
								assetName: eventData.name
							}
						}
					};
				}
			}
		],
		'ddc.form.submission': [
			{
				payload: ({ eventData, mapping }) => {
					let payload = false;
					const { validate, trackingId } = eventData;
					const { formErrorTagging } = mapping?.configuration || {};

					// yes, the not validate part is correct, client wants to know when form is not valid
					if (
						formErrorTagging &&
						typeof validate !== 'undefined' &&
						!validate &&
						trackingId !== 'INVENTORY_SEARCH'
					) {
						const {
							invalidFields = {},
							isModal,
							vehicle
						} = eventData;
						const formError = Object.entries(invalidFields)
							.map(
								([fieldName, fieldValue]) =>
									`${fieldName}: ${fieldValue}`
							)
							.join(', ');

						payload = {
							data: {
								formType: getFormType({
									trackingId,
									mapping
								}),
								events: 'formSubmissionError',
								displayType: formDisplayType(isModal),
								formVehicle: mapVehicle({
									vehicle
								}),
								formError
							}
						};
					}

					return payload;
				}
			}
		],
		'ddc.form.confirmation': [
			{
				payload: ({ mapping, eventData }) => {
					const {
						trackingId = 'DEFAULT',
						params,
						isModal
					} = eventData;

					const acceptedPrefContact = ['EMAIL', 'PHONE', 'TEXT'];
					const data = {
						sessionId: sessionStorage.getItem('userSessionId'),
						formType: getFormType({
							trackingId,
							mapping
						}),
						leadType: 'lead',
						leadId: window.DDC.dataLayer.confirmation.formEventId,
						events: 'formSubmission',
						formVehicle: mapVehicle({
							vehicle: eventData?.vehicle
						}),
						displayType: formDisplayType(isModal)
					};

					const prefContact =
						(window.DDC.dataLayer.confirmation.preferredContact &&
							window.DDC.dataLayer.confirmation.preferredContact.toUpperCase()) ||
						null;

					data.prefContact =
						prefContact &&
						(acceptedPrefContact.indexOf(prefContact) > -1
							? prefContact
							: 'other');

					if (trackingId === 'TRADE_IN') {
						const tradeInData = params
							.split('&')
							.filter(
								(attr) =>
									attr.indexOf('year') > -1 ||
									attr.indexOf('make') > -1 ||
									attr.indexOf('model') > -1
							)
							.reduce((obj, attr) => {
								const keyRaw = attr.substr(
									0,
									attr.indexOf('=')
								);
								let key = '';

								if (keyRaw.indexOf('year') > -1) {
									key = 'year';
								} else if (keyRaw.indexOf('make') > -1) {
									key = 'make';
								} else if (keyRaw.indexOf('model') > -1) {
									key = 'model';
								}

								const val = attr.substr(attr.indexOf('=') + 1);

								// eslint-disable-next-line no-param-reassign
								obj[key] = val;

								return obj;
							}, {});

						data.tradeIn = {
							year: tradeInData.year,
							make: tradeInData.make,
							model: tradeInData.model
						};
					}

					// the below consent stuff handles both GM cemConsent and Genesis endorsedCare conent form checkboxes
					// they both work a little different
					const cemConsentDefaultValue = sessionStorage.getItem(
						'cemConsentDefaultValue'
					);
					const cemConsent =
						window?.DDC?.WidgetData?.['ws-tracking']
							?.confirmationData?.form?.fields?.cemConsent;

					if (cemConsentDefaultValue != null && cemConsent != null) {
						if (
							cemConsent === 'YES_I_CONSENT' ||
							cemConsent === 'checked'
						) {
							data.formOptIn =
								cemConsentDefaultValue === 'true'
									? 'in-implicit'
									: 'in-explicit';
						} else {
							data.formOptIn = 'out';
						}
						sessionStorage.removeItem('cemConsentDefaultValue');
					}

					return {
						data: {
							...data
						}
					};
				}
			}
		],
		'ddc.link.offerClick': [
			{
				payload: ({ eventData }) => {
					const {
						page: { attributes: { incentives = [] } = {} } = {}
					} = window.DDC.dataLayer;

					const applicableIncentive = incentives.filter(
						({ id }) => id === eventData.offerId
					);

					const offerClick = {
						offerId: eventData.offerId,
						offerName: eventData.offerName
					};

					if (applicableIncentive?.length > 0) {
						const {
							type,
							currentVehicleModel,
							currentVehicleBodyStyle,
							applicableTrims,
							applicableYear,
							applicableMake
						} = applicableIncentive[0];

						let currentVehicleModelRevised = currentVehicleModel;
						if (
							applicableMake &&
							currentVehicleModel &&
							currentVehicleModel.match(applicableMake)
						) {
							currentVehicleModelRevised =
								currentVehicleModel.replace(
									`${applicableMake} `,
									''
								);
						}

						let currentVehicleTrims;

						if (applicableTrims && applicableTrims.length > 0) {
							const vehicleIdentifierPattern = `${applicableYear} ${applicableMake} ${currentVehicleModel} ${currentVehicleBodyStyle}`;
							currentVehicleTrims = applicableTrims
								.reduce((collection, trim) => {
									if (trim.match(vehicleIdentifierPattern)) {
										return [
											...collection,
											trim.replace(
												`${vehicleIdentifierPattern} `,
												''
											)
										];
									}
									return [...collection];
								}, [])
								.join('|');
						}

						const applicableIncentiveDataLayer = {
							offerType: (type && type.toLowerCase()) || null,
							vehicleModel: currentVehicleModelRevised,
							vehicleBodyStyle: currentVehicleBodyStyle,
							vehicleYear: applicableYear,
							vehicleTrim: currentVehicleTrims
						};

						Object.assign(offerClick, applicableIncentiveDataLayer);
					}

					return {
						data: {
							events: 'offerClick',
							offerClick
						}
					};
				}
			}
		],
		'ddc.link.getDirections': [
			{
				payload: () => {
					return {
						data: {
							events: 'getDirections'
						}
					};
				}
			}
		],
		'ddc.link.generic': [
			{
				payload: ({ element, eventData }) => {
					return linkGeneric({
						element,
						eventData
					});
				}
			}
		],
		// ddc.form.facetBrowseChange omitted because it never has a trackingId
		// ddc.form.inventorySearchLeadChange omitted because widget no longer used
		// ddc.form.slideChange omitted because it never has a trackingId
		'ddc.form.change': [
			{
				logic: ({ eventData }) => !!eventData.trackingId,
				payload: (args) => handleFormChange(args)
			}
		],
		widgetUserEvent: [
			{
				logic: ({ eventData }) =>
					eventData?.widgetName === 'ws-inv-listing' &&
					eventData?.isWindowStickerLink,
				payload: ({ eventData }) => {
					const data = {
						events: 'linkClick',
						linkText: eventData.elementCTA,
						linkType: 'CTA',
						location: 'content',
						pageType: 'Vehicle Listing'
					};

					if (
						eventData?.url.includes('api/legacy/pse/windowsticker')
					) {
						const { status, year, make, model, vin } = mapVehicle({
							vehicle: eventData?.vehicle || {}
						});

						data.linkType = 'Monroney Label';
						data.vehicle = {
							status,
							year,
							make,
							model,
							vin
						};
					}
					return {
						data
					};
				}
			},
			{
				logic: ({ eventData }) => {
					const {
						page: {
							attributes: { vehicleResultCount } = {},
							pageInfo: {
								isVlp = false,
								pageName = '',
								pageWidgets = []
							} = {}
						} = {}
					} = window.DDC.dataLayer;

					return (
						eventData.widgetName === 'ws-inv-text-search' &&
						eventData.element === 'search form' &&
						eventData.result === 'form submitted' &&
						hasInventoryWidget({
							isVlp,
							pageName,
							pageWidgets,
							vehicleResultCount
						})
					);
				},
				payload: ({ eventData }) => {
					return {
						data: {
							events: 'typedSearch',
							typedSearchContent: eventData.fieldValue
						}
					};
				}
			},
			{
				logic: ({ eventData }) => {
					const {
						page: {
							attributes: { vehicleResultCount } = {},
							pageInfo: {
								isVlp = false,
								pageName = '',
								pageWidgets = []
							} = {}
						} = {}
					} = window.DDC.dataLayer;

					return (
						eventData.result ===
							'Results updated with sort selection' &&
						pageWidgets.includes('ws-inv-listing') &&
						// this test needed because this event and that one use the same getFilterSearchEventPayload logic
						hasInventoryWidget({
							isVlp,
							pageName,
							pageWidgets,
							vehicleResultCount
						})
					);
				},
				payload: () => {
					const filterData = JSON.parse(
						localStorage.getItem('ShiftFilterEvents')
					);
					return getFilterSearchEventPayload({
						eventData: filterData
					});
				}
			}
		],

		specialsEvent: [
			{
				logic: ({ eventData: { specialCategory, specialEvent } }) =>
					specialCategory?.toLowerCase() === 'service' &&
					specialEvent === 'click',
				payload: ({
					eventData: { specialDescription, specialEndDate }
				}) => ({
					data: {
						events: 'serviceOfferClick',
						serviceOfferClick: {
							offerStatus:
								new Date(specialEndDate) > new Date()
									? 'active'
									: 'expired',
							offerName: specialDescription,
							offerExpire: specialEndDate
						}
					}
				})
			},
			{
				logic: ({
					eventData: { widgetName, specialType, specialPlacementType }
				}) =>
					widgetName === 'ws-specials' &&
					specialType === 'click' &&
					specialPlacementType.includes('slide'),
				payload: ({ eventData: { oemId, title, promoIndex } }) => ({
					data: {
						events: 'carouselClick',
						carouselClick: {
							assetName: oemId || title || '',
							assetPosition: promoIndex
						}
					}
				})
			}
		]
	},
	fireGroups: {
		walletClick: {
			maxCount: 1
		}
	}
};
